import {Tooltip as AntTooltip} from "antd";

export const Tooltip = AntTooltip;
export default Tooltip;
